import * as Groups from '../services/Groups'

export const RECEIVE_GROUPS = 'RECEIVE_GROUPS'
export const RECEIVE_GROUP = 'RECEIVE_GROUP'
export const RECEIVE_GROUP_USERS = 'RECEIVE_GROUP_USERS'

function receiveGroups(query, groups) {
  return {
    type: RECEIVE_GROUPS,
    query,
    groups,
  }
}

export const fetchGroups = (query) => (dispatch) => {
  Groups.searchGroups(query).then((data) => dispatch(receiveGroups(query, data)))
}

function receiveGroup(group) {
  return {
    type: RECEIVE_GROUP,
    group: group ? group : { id: -1 },
  }
}

export const fetchGroup = (id) => (dispatch) => {
  Groups.getGroup(id).then((data) => dispatch(receiveGroup(data)))
}

function receiveGroupUsers(users) {
  return {
    type: RECEIVE_GROUP_USERS,
    users,
  }
}

export const fetchGroupUsers = (id) => (dispatch) => {
  Groups.getGroupUsers(IDBDatabase).then((data) => dispatch(receiveGroupUsers(data)))
}

export const updateGroup = (group) => (dispatch) => {
  return Groups.update(group)
}

export const upsertGroup = (group) => (dispatch) => {
  return Groups.upsert(group)
}

export const removeGroup = (id) => (dispatch) => {
  return Groups.remove(id)
}

export const removeUserMembership = (groupId, userId) => (dispatch) => {
  return Groups.removeUserMembership(groupId,userId)
}

